// Moretti mobile format selector stability fix.
if (!document.getElementById('MorettiMobileFormatFix')) {
  const morettiMobileFormatStyle = document.createElement('style');
  morettiMobileFormatStyle.id = 'MorettiMobileFormatFix';
  morettiMobileFormatStyle.textContent = `
    @media screen and (max-width: 749px) {
      product-info[id^="MainProduct-"]
        .product__info-container
        .product-form__input--pill.moretti-format-selector
        input[type="radio"]:checked
        + .moretti-format-card {
        border-width: 1px !important;
        box-shadow: inset 0 0 0 1px #382417 !important;
      }

      .moretti-format-selector
        input[type="radio"]:checked
        + .moretti-format-card
        .moretti-format-card__badge-slot {
        padding-inline: 0.45rem !important;
      }

      .moretti-format-selector
        input[type="radio"]:checked
        + .moretti-format-card
        .moretti-format-card__badge {
        max-width: calc(100% - 1.8rem) !important;
        white-space: nowrap;
      }

      .moretti-format-selector .moretti-format-card__check {
        top: 0.3rem !important;
        right: 0.3rem !important;
        width: 1.4rem !important;
        height: 1.4rem !important;
        font-size: 0.9rem !important;
      }
    }
  `;
  document.head.appendChild(morettiMobileFormatStyle);
}

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.hoverMql = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
        this.thumbnailHoverTimer = null;
        this.formatHoverTimer = null;
        this.lockedMediaId = this.getCurrentMediaId();
        this.formatProductPromise = null;
        this.formatPreviewState = null;
        this.formatPreviewCommitted = false;

        if (this.elements.thumbnails) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        }

        this.setupHoverPreview();
      }

      onSlideChanged(event) {
        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      getCurrentMediaId() {
        const currentThumbnail = this.elements.thumbnails?.querySelector('.thumbnail[aria-current="true"]');
        return (
          currentThumbnail?.closest('[data-target]')?.dataset.target ||
          this.elements.viewer?.querySelector('[data-media-id].is-active')?.dataset.mediaId ||
          this.elements.viewer?.querySelector('[data-media-id]')?.dataset.mediaId ||
          null
        );
      }

      isImageMedia(mediaId) {
        return Boolean(
          this.elements.viewer
            ?.querySelector(`[data-media-id="${mediaId}"]`)
            ?.querySelector('.product__modal-opener--image img')
        );
      }

      setupHoverPreview() {
        if (!this.hoverMql.matches) return;

        this.lockedMediaId = this.getCurrentMediaId();
        this.setupThumbnailHoverPreview();
        this.setupFormatHoverPreview();
      }

      setupThumbnailHoverPreview() {
        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.addEventListener('mouseover', (event) => {
          const item = event.target.closest('[data-target]');
          if (!item || !this.elements.thumbnails.contains(item)) return;
          if (event.relatedTarget && item.contains(event.relatedTarget)) return;

          const target = item.dataset.target;
          window.clearTimeout(this.thumbnailHoverTimer);
          this.thumbnailHoverTimer = window.setTimeout(() => {
            if (this.hoverMql.matches && target && this.isImageMedia(target)) {
              this.previewMedia(target);
            }
          }, 90);
        });

        this.elements.thumbnails.addEventListener('mouseout', (event) => {
          if (event.relatedTarget && this.elements.thumbnails.contains(event.relatedTarget)) return;
          window.clearTimeout(this.thumbnailHoverTimer);
          this.restoreLockedMedia();
        });
      }

      setupFormatHoverPreview() {
        const productInfo = this.closest('product-info');
        if (!productInfo?.querySelector('.moretti-format-selector')) return;

        this.preloadFormatImages(productInfo);

        productInfo.addEventListener('mouseover', (event) => {
          const card = event.target.closest('.moretti-format-card');
          if (!card || !productInfo.contains(card)) return;
          if (event.relatedTarget && card.contains(event.relatedTarget)) return;
          if (card.classList.contains('moretti-format-card--unavailable')) return;

          window.clearTimeout(this.formatHoverTimer);
          this.formatHoverTimer = window.setTimeout(() => {
            this.previewFormatCard(card, productInfo);
          }, 90);
        });

        productInfo.addEventListener('mouseout', (event) => {
          const selector = event.target.closest('.moretti-format-selector');
          if (!selector) return;
          if (event.relatedTarget && selector.contains(event.relatedTarget)) return;

          window.clearTimeout(this.formatHoverTimer);
          if (!this.formatPreviewCommitted) this.restoreFormatPreview();
        });

        productInfo.addEventListener('click', (event) => {
          const card = event.target.closest('.moretti-format-card');
          if (!card || card.classList.contains('moretti-format-card--unavailable')) return;
          this.formatPreviewCommitted = true;
        });
      }

      loadProductJson(productInfo) {
        if (this.formatProductPromise) return this.formatProductPromise;
        const productUrl = productInfo?.dataset.url;
        if (!productUrl) return Promise.resolve(null);

        const endpoint = `${productUrl.replace(/\/$/, '')}.js`;
        this.formatProductPromise = fetch(endpoint, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Product preview fetch failed: ${response.status}`);
            return response.json();
          })
          .catch((error) => {
            console.debug('[Moretti format preview]', error);
            this.formatProductPromise = null;
            return null;
          });

        return this.formatProductPromise;
      }

      getVariantImageSource(variant) {
        const featuredImage = variant?.featured_image;
        if (!featuredImage) return null;
        return typeof featuredImage === 'string' ? featuredImage : featuredImage.src || null;
      }

      sizePreviewImageUrl(src) {
        if (!src) return null;
        try {
          const url = new URL(src, window.location.origin);
          url.searchParams.set('width', '1200');
          return url.href;
        } catch (_error) {
          return src;
        }
      }

      preloadFormatImages(productInfo) {
        this.loadProductJson(productInfo).then((product) => {
          if (!Array.isArray(product?.variants)) return;
          const seen = new Set();

          product.variants.forEach((variant) => {
            const src = this.sizePreviewImageUrl(this.getVariantImageSource(variant));
            if (!src || seen.has(src)) return;
            seen.add(src);
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
          });
        });
      }

      async previewFormatCard(card, productInfo) {
        if (!this.hoverMql.matches) return;
        const inputId = card.getAttribute('for');
        const input = inputId ? document.getElementById(inputId) : null;
        if (!input || input.disabled) return;

        const product = await this.loadProductJson(productInfo);
        if (!Array.isArray(product?.variants)) return;

        const variant = product.variants.find((candidate) => {
          return Array.isArray(candidate.options) && candidate.options.length === 1 && candidate.options[0] === input.value;
        });
        const previewSrc = this.sizePreviewImageUrl(this.getVariantImageSource(variant));
        if (!previewSrc) return;

        const activeMedia =
          this.elements.viewer?.querySelector('[data-media-id].is-active') ||
          this.elements.viewer?.querySelector('[data-media-id]');
        const image = activeMedia?.querySelector('.product__modal-opener--image img');
        if (!image) return;

        if (!this.formatPreviewState || this.formatPreviewState.image !== image) {
          this.restoreFormatPreview();
          this.formatPreviewState = {
            image,
            src: image.getAttribute('src'),
            srcset: image.getAttribute('srcset'),
            sizes: image.getAttribute('sizes'),
          };
        }

        this.formatPreviewCommitted = false;
        image.removeAttribute('srcset');
        image.src = previewSrc;
      }

      restoreFormatPreview() {
        const state = this.formatPreviewState;
        if (!state?.image?.isConnected) {
          this.formatPreviewState = null;
          this.formatPreviewCommitted = false;
          return;
        }

        if (state.srcset === null) state.image.removeAttribute('srcset');
        else state.image.setAttribute('srcset', state.srcset);

        if (state.sizes === null) state.image.removeAttribute('sizes');
        else state.image.setAttribute('sizes', state.sizes);

        if (state.src !== null) state.image.setAttribute('src', state.src);
        this.formatPreviewState = null;
        this.formatPreviewCommitted = false;
      }

      discardFormatPreview() {
        this.formatPreviewState = null;
        this.formatPreviewCommitted = false;
      }

      restoreLockedMedia() {
        if (!this.lockedMediaId || !this.isImageMedia(this.lockedMediaId)) return;
        if (this.getCurrentMediaId() === this.lockedMediaId) return;
        this.previewMedia(this.lockedMediaId);
      }

      previewMedia(mediaId) {
        this.activateMedia(mediaId, false, true);
      }

      setActiveMedia(mediaId, prepend) {
        this.lockedMediaId = mediaId;
        this.discardFormatPreview();
        this.activateMedia(mediaId, prepend, false);
      }

      activateMedia(mediaId, prepend, previewMode) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;
        if (previewMode && !activeMedia.querySelector('.product__modal-opener--image img')) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (activeThumbnail && activeThumbnail.parentElement.firstChild !== activeThumbnail) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        if (!previewMode) this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }

          // Hover previews never move the page vertically.
          if (previewMode || prepend) return;

          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        if (!previewMode) this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (!previewMode && activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
